import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=d4813308&"
import script from "./PdfPreview.vue?vue&type=script&lang=js&"
export * from "./PdfPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4813308')) {
      api.createRecord('d4813308', component.options)
    } else {
      api.reload('d4813308', component.options)
    }
    module.hot.accept("./PdfPreview.vue?vue&type=template&id=d4813308&", function () {
      api.rerender('d4813308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/PdfPreview.vue"
export default component.exports